export default __webpack_public_path__ + "static/media/IEEE logo.5ac10ed8.png";